<p-panelMenu
    [model]="items"
    id="left-menu"
    [multiple]="false"
></p-panelMenu>